//# sourceMappingURL=svg.mjs.map
/// <reference types="./svg.d.mts" />
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $svg from "../../../redraw_dom/redraw/dom/svg.mjs";
import * as $a_ from "../../../redraw_dom/redraw/dom/svg/attribute.mjs";
import { toList, prepend as listPrepend } from "../../gleam.mjs";

function compute_view_box(width, height) {
  let width$1 = $int.to_string(width);
  let height$1 = $int.to_string(height);
  return $string.join(toList(["0", "0", width$1, height$1]), " ");
}

export function view_(width, height, attrs, content) {
  let viewbox = compute_view_box(width, height);
  let viewbox$1 = $a_.viewbox(viewbox);
  let fill = $a_.fill("none");
  let content$1 = $a.inner_html(content);
  let content$2 = $a.dangerously_set_inner_html(content$1);
  return $svg.svg(
    listPrepend(viewbox$1, listPrepend(fill, listPrepend(content$2, attrs))),
    toList([]),
  );
}

export function view(width, height, content) {
  return view_(width, height, toList([]), content);
}

export function square(size, content) {
  return view(size, size, content);
}

export function square_(size, attributes, content) {
  return view_(size, size, attributes, content);
}
